import { createFileRoute } from "@tanstack/react-router";

import { NewGroupForm } from "../components/group/new-group-form";

/** A Secret Santa: a draw among participants, each with a list the drawer can read. */
export const Route = createFileRoute("/secret-santa_/nouveau")({
  component: () => <NewGroupForm kind="secret_santa" />,
});
